// extracted by mini-css-extract-plugin
export default {"container":"HeadingTop_container__+oztW","heading":"HeadingTop_heading__fx1r1","subheading":"HeadingTop_subheading__kO5lj","hr":"HeadingTop_hr__TGSIJ"};